import React, {Component} from 'react';
import cx from 'classnames';

// change settings for image stops here
const settings = {
    scrollSpeed: 1,
    img1InitialPositionPercentage: -100,
    img1BreakPercentage: -0.1, // equivalent to 'right: -10%'
    img2BreakPercentage: -0.2,
    img3BreakPercentage: -0.3,
    scrollStandstillPercentage: 0.3
};

export default class MakeContentScroll extends Component {
    constructor(){
        super();
        this.setBreakpoint = this.setBreakpoint.bind(this);
        this.setImgPosition = this.setImgPosition.bind(this);
        this.shouldTriggerAnimation = this.shouldTriggerAnimation.bind(this);
        this.returnImg1Style = this.returnImg1Style.bind(this);
        this.returnImg2Style = this.returnImg2Style.bind(this);
        this.returnImg3Style = this.returnImg3Style.bind(this);
        this.returnContainerStyle = this.returnContainerStyle.bind(this);
        this.state = {
            img1_x: `${settings.img1InitialPositionPercentage}%`, //
            img2_x: `${settings.img1InitialPositionPercentage - 100 - (settings.img1BreakPercentage * 100)}%`,
            img3_x: `${settings.img1InitialPositionPercentage - 200 - (settings.img1BreakPercentage * 100) - (settings.img2BreakPercentage * 100)}%`,
            img3_x_prev: null,
            triggerMainImgReposition: false,
            triggerImg1Reposition: false,
            triggerImg2Reposition: false
        }
    }

    componentDidMount(){
        // set breakpoint when page loads i.e. when img3 reaches right: -30%;
        this.setBreakpoint();
        // in case of page reload, this sets img x positions
        this.setImgPosition();

        window.addEventListener('scroll', this.setImgPosition);
        window.addEventListener('resize', () => {
            this.setBreakpoint();
            this.setImgPosition();
        });
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.setImgPosition);
        window.removeEventListener('resize', () => {
            this.setBreakpoint();
            this.setImgPosition();
        });
    }

    setBreakpoint(){
        const {setContentContainerOffset} = this.props;
        const windowWidth = window.innerWidth;
        const img1Ratio = 1 + settings.img1BreakPercentage;
        const img2Ratio = 1 + settings.img2BreakPercentage;
        const img3Ratio = 1 + settings.img3BreakPercentage;
        const totalMultiplier = img1Ratio + img2Ratio + img3Ratio + settings.scrollStandstillPercentage;

        const breakPointOffset = (windowWidth - 15) * totalMultiplier.toFixed(2);

        return setContentContainerOffset(breakPointOffset);
    }

    setImgPosition(){
        const {img3_x, img3_x_prev} = this.state;
        const currentPos = window.scrollY;
        let photoWidth = document.getElementById('img1') ? document.getElementById('img1').clientWidth : null;
        const position = currentPos / photoWidth;

        // percentage moved based on yscroll
        const newXPercentagePos = (position * 100) - 100;
        const new_img1_x = `${newXPercentagePos}%`;
        //start img2 offset by img1breakpercentage
        const new_img2_x = `${newXPercentagePos - (100 + (settings.img1BreakPercentage * 100))}%`;
        // start img3 offset by img1breakpercentage + img2breakpercentage
        const new_img3_x = `${newXPercentagePos - ((100 + (settings.img1BreakPercentage * 100)) + (100 + (settings.img2BreakPercentage * 100)))}%`;
        const prevImg3Pos = img3_x_prev === null ? newXPercentagePos : img3_x;
        const triggerMainImgReposition = this.shouldTriggerAnimation(new_img1_x, 'img1');
        const triggerImg1Reposition = this.shouldTriggerAnimation(new_img2_x, 'img2');
        const triggerImg2Reposition = this.shouldTriggerAnimation(new_img3_x, 'img3');

        this.setState({
            img1_x: new_img1_x,
            img2_x: new_img2_x,
            img3_x: new_img3_x,
            img3_x_prev: prevImg3Pos,
            triggerMainImgReposition,
            triggerImg1Reposition,
            triggerImg2Reposition
        });
    }

    shouldTriggerAnimation(newPosition, imgClass){
        switch(imgClass){
            case 'img1':
                return parseFloat(newPosition) > (settings.img1BreakPercentage * 100) ? true : false;
                break;
            case 'img2':
                return parseFloat(newPosition) > (settings.img2BreakPercentage * 100) ? true: false;
                break;
            case 'img3':
                return parseFloat(newPosition) > (settings.img3BreakPercentage * 100) ? true : false;
                break;
            default:
                return false;
        }
    }

    returnImg1Style(){
        const {img1_x} = this.state;

        if(parseFloat(img1_x) > (settings.img1BreakPercentage * 100)){
            // position img1 exactly at -10%
            return {
                position: 'absolute',
                right: `${settings.img1BreakPercentage * 100}%`
            };
        } else {
            // position img1 based on scroll
            return {
                right: img1_x
            };
        }
    }

    returnImg2Style(){
        const {img2_x} = this.state;

        if(parseFloat(img2_x) > (settings.img2BreakPercentage * 100)){
            return {
                position: 'absolute',
                right: `${settings.img2BreakPercentage * 100}%`
            };
        } else {
            return {
                right: img2_x
            };
        }
    }

    returnImg3Style(){
        const {img3_x} = this.state;

        if(parseFloat(img3_x) > (settings.img3BreakPercentage * 100)){
            return {
                position: 'absolute',
                right: `${settings.img3BreakPercentage * 100}%`
            };
        } else {
            return {
                right: img3_x
            };
        }
    }

    returnContainerStyle(){
        const {img3_x} = this.state;
        const {containerOffset} = this.props;

        if(parseFloat(img3_x) > ((settings.img3BreakPercentage + settings.scrollStandstillPercentage) * 100)){
            return {
                position: 'absolute',
                top: containerOffset
            };
        } else {
            return {
                position: 'fixed'
            };
        }
    }

    render(){
        const {triggerMainImgReposition, triggerImg1Reposition, triggerImg2Reposition} = this.state;
        const containerStyle = this.returnContainerStyle();
        const img1style = this.returnImg1Style();
        const img2style = this.returnImg2Style();
        const img3style = this.returnImg3Style();
        const mainClassNames = cx('main', {'main-animate': triggerMainImgReposition});
        const img1ClassNames = cx('img1', {'img1-animate': triggerImg1Reposition});
        const img2ClassNames = cx('img2', {'img2-animate': triggerImg2Reposition});

        return(
            <div className='gr-12 make-content-scroll' style={containerStyle}>
                <div className={mainClassNames}>
                    <div className='main-text'>
                        <p>High performing</p>
                        <p className='text-emphasis'>branded content</p>
                        <p>is just a click away</p>
                        <a href='#contact-form'><button className='hide@xs'>Get Started</button></a>
                    </div>
                </div>
                <div id='img1' className={img1ClassNames} style={img1style}></div>
                <div id='img2' className={img2ClassNames} style={img2style}></div>
                <div id='img3' className='img3' style={img3style}>
                    <div className='gr-4 push-4 make-content-scroll-text'>
                        <h1>We're changing the way brands make content</h1>
                        <p>Drive powerful results with content that's fresh, authentic and already proven to engage. Create custom content from the lens of your consumers, for your consumers.</p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/branded_content/make_content_scroll.js